<template>
  <div>
    <b-form-group label="Nome:">
      <b-form-input
        v-model="valueForm.nome"
        placeholder="Nome"
        :state="validateState('nome')"
      ></b-form-input>
      <b-form-invalid-feedback>
        Nome é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="CPF:">
      <b-form-input
        v-model="valueForm.cpf"
        :formatter="formatterCpf"
        placeholder="CPF"
        :state="validateState('cpf')"
      ></b-form-input>
      <b-form-invalid-feedback>
        CPF é um campo obrigatório.
      </b-form-invalid-feedback>
    </b-form-group>

    <b-form-group label="RG:">
      <b-form-input v-model="valueForm.rg" placeholder="RG"></b-form-input>
    </b-form-group>

    <b-form-group label="Data Nascimento:">
      <b-form-input
        v-model="valueForm.data_nascimento"
        placeholder="Data Nascimento"
        v-mask="'##/##/####'"
      ></b-form-input>
    </b-form-group>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { cpf } from "cpf-cnpj-validator";
import getPersonEmpty from "@/components/Form/PessoaFisica/get_pessoa_fisica_empty";
import { formatBirthday } from "@/modules/clientes/store/actions";

export default {
  mixins: [validationMixin],
  data: () => ({}),
  props: {
    value: {},
  },
  validations: {
    value: {
      nome: {
        required,
        minLength: minLength(3),
      },
      cpf: {
        required,
        cpf: (value) => {
          return !value || cpf.isValid(value);
        },
      },
    },
  },
  watch: {
    "valueForm.data_nascimento"(val) {
      if (val) {
        this.valueForm.data_nascimento = formatBirthday(val);
      }
    },
  },
  computed: {
    valueForm: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.value[name];
      return $dirty ? !$error : null;
    },
    isValid() {
      this.$v.value.$touch();
      return !this.$v.value.$anyError;
    },
    formatterCpf(value) {
      const cpfPattern = /^(\d{3})(\d{3})(\d{3})(\d{2})/;
      const formattedValue = value
        .replace(/\D/g, "")
        .substring(0, 11)
        .replace(cpfPattern, "$1.$2.$3-$4");

      return formattedValue;
    },
  },
  mounted() {
    const legalPersonInfo = Object.assign({}, getPersonEmpty(), this.value);
    this.$emit("input", legalPersonInfo);
  },
  beforeDestroy() {
    this.$emit("input", getPersonEmpty);
  },
};
</script>
